import { Pipe, PipeTransform } from "@angular/core";
import { Role } from "../enum/role";

@Pipe({
    name: "role",
})
export class RolePipe implements PipeTransform {
    transform(role: Role): string {
        switch (role) {
            case Role.SuperAdmin:
                return "Super Admin";
            case Role.Assigner:
                return "Assigner";
            case Role.Approver:
                return "Approver";
            case Role.Checker:
                return "Checker";
            case Role.Maker:
                return "Maker";
            default:
                return "";
        }
    }
}
